import React, { forwardRef, ComponentType, ReactNode } from 'react';
import { SC } from 'ia-react-core/~/interfaces/SC';
import { SCP } from 'ia-react-core/~/interfaces/SCP';
import { WithAnalytics } from 'ia-react-core/~/interfaces/WithAnalytics';

import { StyledLink, StyledLeftIcon, StyledRightIcon } from './Link.styles';

export interface LinkProps extends WithAnalytics, SCP<'a'> {
  children?: ReactNode;
  /** Icon to display left of the button */
  LeftIcon?: ComponentType<any>;
  /** Icon to display left of the button */
  RightIcon?: ComponentType<any>;
  /** Determine if the link should wrap or not */
  noWrap?: boolean;
}

interface LinkPropsStatics {
  StyledLink: typeof StyledLink;
  defaultProps: Partial<LinkProps>;
}

const LinkDefaultProps: Partial<LinkProps> = {
  noWrap: true,
};

const Link = Object.assign(
  forwardRef<HTMLAnchorElement, LinkProps>(({ LeftIcon, RightIcon, children, noWrap, ...props }, ref) => (
    <StyledLink<string | ComponentType<any>>
      data-testid="Link"
      LeftIcon={LeftIcon}
      ref={ref}
      $noWrap={noWrap}
      {...props}
    >
      {LeftIcon && <StyledLeftIcon as={LeftIcon} />}
      {children}
      {RightIcon && <StyledRightIcon as={RightIcon} />}
    </StyledLink>
  )),
  {
    displayName: 'Link',
    StyledLink,
  },
) as SC<'a', LinkProps> & LinkPropsStatics;

Link.defaultProps = LinkDefaultProps;

export default Link;
